import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import fetch from 'cross-fetch'
import { setContext } from '@apollo/client/link/context'
import { v4 as uuidv4 } from 'uuid'

import { environment } from '../environments/environment'
import { DefaultContext } from '@apollo/client'

const httpLink = new HttpLink({
  uri: environment.graphqlPath,
  fetch,
})

const authLink = setContext(
  (_, { headers }): DefaultContext | Promise<DefaultContext> => {
    // get the authentication token from session storage if it exists

    const token = sessionStorage.getItem(
      `oidc.user:${environment.auth.authority}:${environment.auth.client_id}`,
    )

    if (!token) {
      return {} // Return an empty object instead of undefined
    }
    const parsedToken = JSON.parse(token)
    const accessToken = parsedToken.access_token

    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${accessToken}` : '',
        'x-transaction-id': uuidv4(),
      },
    }
  },
)

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      SelectItemInt: {
        keyFields: false,
      },
    },
  }),
})
